import * as Yup from 'yup';

export const proctorResultFormSchema = Yup.object().shape({
    proctorFileName: Yup.string().required('Proctor file name is required'),
    proctorDate: Yup.string().required('Proctor date is required'),
});
